<template>
    <router-view v-slot="{ Component, route }">
        <Transition name="view" appear>
            <component :is="Component" :key="route.path" />
        </Transition>
    </router-view>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
});
</script>

<style scoped lang="scss">
.view-enter-active {
    transition: all 0.3s ease-in-out;
}

.view-leave-active {
    display: none;
}

/* .view-leave-to, */
.view-enter-from {
    transform: translateX(20px);
    opacity: 0;
}
</style>
